/**
 * Client-side slice of the workflow helpers — just the display
 * formatting the UI needs. The full workflow engine (transition
 * validation, state graphs) stays server-side; the client only
 * renders names the server already resolved.
 */

const STATE_DISPLAY_LABELS: Record<string, string> = {
  waiting_on_dependency: "waiting on another ticket",
  spec_drafting: "creating specification",
  spec_client_review: "specification approval",
  merge_to_dev: "merge into dev",
  merge_to_test: "merge into test",
  merge_to_main: "merge into production",
  internal_test_dev: "internal testing on dev",
  client_test_dev: "client testing on dev",
  internal_test_test: "internal testing on test",
  client_test_test: "client testing on test",
  internal_test_main: "internal testing on production",
  client_test_main: "client testing on production",
  // Legacy names may still appear in historical journals / logs.
  dev_review: "deploying to dev",
  ready_for_test: "deploying to test",
  testing_on_test: "testing on test",
  release_queue: "in release queue",
};

/** Human-readable status name — verbatim port of `displayStateName`. */
export function displayStateName(name: string | null | undefined): string {
  if (!name) return "";
  return STATE_DISPLAY_LABELS[name] ?? name.replace(/_/g, " ");
}
